import Vue from 'vue'
export default {
  onAppLaunch(vm) {
    // 管理員選擇器
    Vue.prototype.$userSelector = ({ applyCallback, closeCallback = null, usedList = [] }) => {
      vm.$targetSelector.active(vm, {
        title: vm.i18n('module.user'),
        bodySlot: () => import('modules/user/selector/userList.vue'),
        applyCallback,
        closeCallback,
        usedList,
      })
    }

    // 管理員物件選擇器
    Vue.prototype.$userGroupSelector = ({ applyCallback, closeCallback = null, usedList = [], meta = {} }) => {
      vm.$targetSelector.active(vm, {
        title: '管理員群組',
        bodySlot: () => import('modules/user/selector/userGroupList.vue'),
        applyCallback,
        closeCallback,
        usedList,
        ...meta,
      })
    }
  },
}